<template>
  <v-navigation-drawer
    :value="isDrawerOpen"
    app
    floating
    width="260"
    class="app-navigation-menu"
    :right="$vuetify.rtl"
    @input="(val) => $emit('update:is-drawer-open', val)"
  >
    <div class="vertical-nav-header d-flex items-center ps-6 pe-5 pt-5 pb-2">
      <router-link
        to="/school-dashboard"
        class="d-flex align-center text-decoration-none"
        @click.native="reloadPage"
      >
        <v-img
          :src="require('@/assets/images/logos/logo_4_small_bustracker.png')"
          max-height="30px" max-width="30px"
          alt="logo" contain eager class="app-logo me-3"
        ></v-img>
        <v-slide-x-transition>
          <h2 class="app-title text--primary">{{ systemName }}</h2>
        </v-slide-x-transition>
      </router-link>
    </div>

    <v-list expand shaped class="vertical-nav-menu-items pr-5 nav-list-bottom">
      <nav-menu-link
        :title="$t('sidebar.dashboard')"
        :to="{ name: 'school-dashboard' }"
        :icon="icons.mdiHomeOutline"
        color="#e65100"
      ></nav-menu-link>

      <nav-menu-section-title :title="$t('sidebar.users')"></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.students')"
        :to="{ name: 'students' }"
        icon="mdi-badge-account-outline"
        color="#F57C00"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('sidebar.guardians')"
        :to="{ name: 'guardians' }"
        icon="mdi-account-group-outline"
        color="#7B1FA2"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('sidebar.drivers')"
        :to="{ name: 'drivers' }"
        icon="mdi-account-tie-hat"
        color="#1976D2"
      ></nav-menu-link>

      <nav-menu-section-title :title="$t('sidebar.system_setup')"></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.classes')"
        :to="{ name: 'classes' }"
        icon="mdi-google-classroom"
        color="#388E3C"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('sidebar.buses')"
        :to="{ name: 'buses' }"
        icon="mdi-bus-multiple"
        color="#e65100"
      ></nav-menu-link>

      <nav-menu-section-title :title="$t('sidebar.live')"></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.live_tracking')"
        :to="{ name: 'live-tracking' }"
        icon="mdi-crosshairs-gps"
        color="#e65100"
      ></nav-menu-link>

      <nav-menu-section-title :title="$t('sidebar.reports')"></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.bus_reports')"
        :to="{ name: 'school-reports' }"
        icon="mdi-bus-clock"
        color="#F57C00"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('sidebar.ride_history')"
        :to="{ name: 'school-ride-history' }"
        icon="mdi-map-marker-path"
        color="#00897B"
      ></nav-menu-link>
      <nav-menu-link
        :title="$t('sidebar.student_reports')"
        :to="{ name: 'school-student-reports' }"
        icon="mdi-account-clock-outline"
        color="#1976D2"
      ></nav-menu-link>

      <nav-menu-section-title :title="$t('sidebar.general')"></nav-menu-section-title>
      <nav-menu-link
        :title="$t('sidebar.notifications')"
        :to="{ name: 'school-notifications' }"
        icon="mdi-bell-outline"
        color="#7B1FA2"
      ></nav-menu-link>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import { mdiHomeOutline, mdiCrosshairsGps } from '@mdi/js';
import NavMenuSectionTitle from './components/NavMenuSectionTitle.vue';
import NavMenuLink from './components/NavMenuLink.vue';
import { Keys } from '/src/config.js';

export default {
  components: { NavMenuSectionTitle, NavMenuLink },
  props: {
    isDrawerOpen: { type: Boolean, default: null },
  },
  setup() {
    return {
      icons: { mdiHomeOutline, mdiCrosshairsGps },
      systemName: Keys.VUE_APP_SYSTEM_NAME,
    };
  },
  methods: {
    reloadPage() { window.location.reload(); },
  },
};
</script>

<style lang="scss" scoped>
.app-title { font-size: 1.25rem; font-weight: 700; letter-spacing: 0.3px; }
@include theme(app-navigation-menu) using ($material) {
  background-color: map-deep-get($material, 'background');
}
.nav-list-bottom {
  padding-bottom: calc(56px + env(safe-area-inset-bottom, 0px)) !important;
}
</style>